import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function StorySection() {
  return <section className="bg-navy-900 py-20 md:py-28 relative text-cream-50" data-id="element-309">
      <div className="container mx-auto px-4" data-id="element-310">
        <div className="max-w-[680px] mx-auto" data-id="element-311">
          <FadeIn data-id="element-312">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-center mb-12 text-white" data-id="element-313">
              Esta noche no tiene que verse igual
            </h2>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-314">
            <div className="prose prose-lg md:prose-xl mx-auto text-cream-100/80" data-id="element-315">
              <p className="mb-6 leading-relaxed" data-id="element-316">
                Conoces bien la rutina. Te despiertas en la madrugada,
                intentando no hacer ruido. Caminas en la oscuridad hacia el
                baño, esperando un alivio que a veces tarda en llegar o se
                siente incompleto.
              </p>
              <p className="mb-6 leading-relaxed" data-id="element-317">
                Vuelves a la cama, pero el sueño profundo ya se ha interrumpido.
                Al día siguiente, la fatiga te acompaña como una sombra
                constante.
              </p>
              <p className="mb-6 leading-relaxed" data-id="element-318">
                Muchos hombres asumen que esto es simplemente una parte
                inevitable de madurar. Que la única opción es resignarse a
                dormir a medias.
              </p>
              <div className="bg-navy-800/50 border-l-2 border-gold-500 p-6 rounded-r-xl mt-10" data-id="element-319">
                <p className="text-xl font-heading text-white m-0 leading-relaxed" data-id="element-320">
                  Pero cuando entiendes qué factores en tu rutina nocturna están
                  activando tu vejiga, puedes empezar a descansar de otra
                  manera.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}